import {format} from 'date-fns';
import i18n from 'i18next';

import {locales} from '../core/localization';

export function formatDate(date: string | Date, dateFormat = 'dd.MM.yyyy') {
    if (typeof date === 'string') {
        date = new Date(date);
    }
    return format(new Date(date), dateFormat, {locale: locales[i18n.language]});
}

export function shiftTimeZone(value: Date) {
    const date = new Date(value);
    date.setUTCMinutes(date.getUTCMinutes() - date.getTimezoneOffset());
    return date;
}

export const getPastDate = (from: Date, daysAgo: number) => {
    const date = new Date(from);
    return new Date(date.setDate(date.getDate() - daysAgo));
};

export const getLastDayOfMonth = (value: Date = new Date()) => {
    const date = new Date(value);
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
};

export const getFirstDayOfMonth = (value: Date = new Date()) => {
    const date = new Date(value);
    return new Date(date.getFullYear(), date.getMonth(), 1);
};
